const TOKEN = localStorage.getItem("token");
export const config = {
  // api's base url
  baseURL: "https://api-dev.televerse.me/",
  // requeired headers
  headers: {
    "Content-Type": "application/json",
    Authorization:
      TOKEN && TOKEN.includes("Bearer") ? TOKEN : `Bearer ${TOKEN}`,
  },
};
